import { PUBLIC_DIFFUSION_API_ENDPOINT } from '$env/static/public';
import {
	Client as DiffusionApiClient,
	type UploadedImage,
	type UploadedImagePatch
} from '$lib/diffusionApi';

export class UploadedImagesClient {
	private diffusionApiClient: DiffusionApiClient;

	constructor(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public setToken(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public async createUploadedImage(image: string) {
		try {
			const response = await this.diffusionApiClient.default.createUploadedImageUploadedImagePost({
				image
			});
			return response;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async getUploadedImages(
		user_id: string,
		config?: {
			skip?: number;
			limit?: number;
			most_recent_first?: boolean;
			upload_ids?: string[];
			journey_id?: string;
		}
	): Promise<UploadedImage[]> {
		const response = await this.diffusionApiClient.default.getUploadedImagesUploadedImagesGet(
			user_id,
			config?.skip,
			config?.limit,
			config?.most_recent_first,
			config?.upload_ids,
			config?.journey_id
		);
		return response.uploaded_images;
	}

	public async patchUploadedImages(patches: UploadedImagePatch[]) {
		try {
			const response = await this.diffusionApiClient.default.patchUploadedImagesUploadedImagesPatch(
				{
					patches
				}
			);
			return response;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}
}
